/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Added_To_Group_SuccessInputs */

const en_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User added to group successfully`)
};

const fr_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateur ajouté au groupe avec succès`)
};

const de_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer erfolgreich zur Gruppe hinzugefügt`)
};

const it_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utente aggiunto al gruppo con successo`)
};

const ru_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь успешно добавлен в группу.`)
};

const es_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario añadido al grupo exitosamente`)
};

const zh_cn2_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户已成功添加到组`)
};

const ja_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーがグループに正常に追加されました`)
};

const hi_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को समूह में सफलतापूर्वक जोड़ दिया गया है।`)
};

const pt_pt2_team_manager_user_added_to_group_success = /** @type {(inputs: Team_Manager_User_Added_To_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário adicionado ao grupo com sucesso`)
};

/**
* | output |
* | --- |
* | "User added to group successfully" |
*
* @param {Team_Manager_User_Added_To_Group_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_added_to_group_success = /** @type {((inputs?: Team_Manager_User_Added_To_Group_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Added_To_Group_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_added_to_group_success(inputs)
	if (locale === "de") return de_team_manager_user_added_to_group_success(inputs)
	if (locale === "it") return it_team_manager_user_added_to_group_success(inputs)
	if (locale === "ru") return ru_team_manager_user_added_to_group_success(inputs)
	if (locale === "es") return es_team_manager_user_added_to_group_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_added_to_group_success(inputs)
	if (locale === "ja") return ja_team_manager_user_added_to_group_success(inputs)
	if (locale === "hi") return hi_team_manager_user_added_to_group_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_added_to_group_success(inputs)
	return en_team_manager_user_added_to_group_success(inputs)
});